import { useEffect } from 'react';
import { CustomProps, trackGenericPage } from '.';
import { MixpanelPage } from './events';

export const useMixpanelTrackPage = (pageName: MixpanelPage, customProps?: Partial<CustomProps>): void => {
  useEffect(() => {
    trackGenericPage(pageName, customProps);
  }, []);
};
